import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  ArrowLeft,
  Network,
  Sparkles,
  TreePine,
} from "lucide-react";
import { RootState } from "../../../../../store";
import {
  PRODUCT_IMAGE_FALLBACK,
  earningsStatusClass,
  formatEarningsCurrency,
  statusLabel,
} from "../../earningsAdapters";
import "../SalarFlowPage.css";

const ReferralCommDetails = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderNo = queryParams.get("orderNo") || "";

  const { flowCommission } = useSelector(
    (state: RootState) => state.referral,
  );

  const item = flowCommission.data?.find((i) => i.orderNo === orderNo);

  if (!item) {
    return (
      <section className="ri-page">
        <div className="ri-shell">
          <header className="ri-page-header">
            <div className="ri-page-title">
              <span className="ri-title-icon">
                <Sparkles size={25} />
              </span>
              <div>
                <span className="ri-eyebrow">SALAR FLOW</span>
                <h1>Details Not Found</h1>
                <p>Details not found for order: {orderNo || "—"}</p>
              </div>
            </div>
            <a href="/ReferralCommission" className="ri-outline-action">
              <ArrowLeft size={18} />
              Back to List
            </a>
          </header>
        </div>
      </section>
    );
  }

  return (
    <section className="ri-page">
      <div className="ri-shell">
        <header className="ri-page-header">
          <div className="ri-page-title">
            <span className="ri-title-icon">
              <Sparkles size={25} />
            </span>
            <div>
              <span className="ri-eyebrow">SALAR FLOW</span>
              <h1>Salar Flow Incentive Details</h1>
              <p>Order {item.orderNo} · Complete incentive breakdown.</p>
            </div>
          </div>
          <a href="/ReferralCommission" className="ri-outline-action">
            <ArrowLeft size={18} />
            Back to List
          </a>
        </header>

        <div className="ri-table-wrap" style={{ padding: "16px 18px" }}>
          <span className="ri-eyebrow">ORDER DETAILS</span>
          <div
            className="ri-incentive-lines"
            style={{ marginTop: "10px" }}
          >
            <div>
              <span>Order Date</span>
              <strong>
                {item.orderDateFormatted || item.orderDate}
                {item.orderTime ? ` (${item.orderTime})` : ""}
              </strong>
            </div>
            <div>
              <span>Order No</span>
              <strong>{item.orderNo}</strong>
            </div>
          </div>
        </div>

        <div
          className="ri-table-wrap"
          style={{ padding: "16px 18px", marginTop: "14px" }}
        >
          <span className="ri-eyebrow">PRODUCT DETAILS</span>
          <div className="ri-product-cell" style={{ marginTop: "10px" }}>
            <img src={PRODUCT_IMAGE_FALLBACK} alt="" />
            <div>
              <p>
                <b>Product Name:</b> {item.productDetails?.productName}
              </p>
              <p>
                <b>Order Type:</b> {item.productDetails?.orderType}
              </p>
              <p>
                <b>SF Network No:</b> {item.productDetails?.sfNetworkNo}
              </p>
            </div>
          </div>
        </div>

        <div
          className="ri-table-wrap"
          style={{ padding: "16px 18px", marginTop: "14px" }}
        >
          <span className="ri-eyebrow">REFERRAL NETWORK STATUS</span>
          <div
            className="ri-incentive-lines"
            style={{ marginTop: "10px" }}
          >
            <div>
              <span>Req. Contributors</span>
              <strong>
                {item.productDetails?.contributionRequirement ?? 0}
              </strong>
            </div>
            <div>
              <span>Active Contributors</span>
              <strong>
                {item.productDetails?.activeContributors ?? 0}
              </strong>
            </div>
            <div>
              <span>Status</span>
              <strong>
                <span
                  className={earningsStatusClass(
                    item.referralNetworkStatus?.status,
                  )}
                >
                  {statusLabel(item.referralNetworkStatus?.status)}
                </span>
              </strong>
            </div>
            <div>
              <span>Referral Incentives</span>
              <strong>
                {formatEarningsCurrency(item.referralIncentives)}
              </strong>
            </div>
          </div>
          <div className="ri-network-actions" style={{ marginTop: "12px" }}>
            <a
              className="ri-view-button"
              href={`/ReferralCommissoinTeam?orderNo=${item.orderNo}`}
            >
              <Network size={15} />
              Team
            </a>{" "}
            <a
              className="ri-view-button"
              href={`/Tree?orderNo=${item.orderNo}&type=referral`}
            >
              <TreePine size={15} />
              Tree
            </a>
          </div>
        </div>

        <div
          className="ri-table-wrap"
          style={{ padding: "16px 18px", marginTop: "14px" }}
        >
          <span className="ri-eyebrow">NOVA REFERRAL NETWORK</span>
          <div
            className="ri-incentive-lines"
            style={{ marginTop: "10px" }}
          >
            <div>
              <span>Req. Contributors</span>
              <strong>
                {item.novaReferralNetwork?.contributionRequirement ?? 0}
              </strong>
            </div>
            <div>
              <span>Active Contributors</span>
              <strong>
                {item.novaReferralNetwork?.activeContributors ?? 0}
              </strong>
            </div>
            <div>
              <span>Earned Incentives</span>
              <strong>
                {formatEarningsCurrency(
                  item.novaReferralNetwork?.earnedIncentives,
                )}
              </strong>
            </div>
          </div>
          <div className="ri-network-actions" style={{ marginTop: "12px" }}>
            <a
              className="ri-view-button"
              href={`/NovaCommissionTeam?orderNo=${item.orderNo}`}
            >
              <Network size={15} />
              Team
            </a>{" "}
            <a
              className="ri-view-button"
              href={`/Tree?orderNo=${item.orderNo}&type=nova`}
            >
              <TreePine size={15} />
              Tree
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralCommDetails;
